import {Component, ElementRef, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {SaveComponent} from "../comptabilite/detail-tresorerie/save/save.component";

import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {HeaderService} from "../../../services/header/header.service";
import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr";
import {DataService, Quote} from "../../../services/commande-client/data.service";

@Component({
  selector: 'app-filtre-date',
  templateUrl: './filtre-date.component.html',
  styleUrls: ['./filtre-date.component.scss']
})
export class FiltreDateComponent implements OnInit {

    @ViewChild('datePicker') datePicker!: ElementRef;
    @ViewChild('save') saveComponent!: SaveComponent;
    
    @Output() dateFilterChange = new EventEmitter<{startDate: string, endDate: string}>();


    retour() {
        this.router.navigate(['/comptabilite/tresorerie']);
    }

    viewMode: 'jours' | 'mois' | 'annees' = 'jours';
    weekDays: { label: string; dateString: string; isToday: boolean }[] = [];

    currentMonthIndex = new Date().getMonth();
    currentYear = new Date().getFullYear();
    items = [{
        date: "10/04/2025",
        type: "Espèces",
        ttc: "Paiement facture de vente",
        document: "FAC-000001",
        debit: "--",
        credit: "100,600 TND"
    },
        {
            date: "11/04/2025",
            type: "Virement",
            ttc: "Paiement facture de vente",
            document: "FAC-000002",
            debit: "--",
            credit: "50,000 TND"
        },
        {
            date: "12/04/2025",
            type: "Espèces",
            ttc: "Achat fournitures ",

            document: "ACH-000010",
            debit: "--",
            credit: "10,000 TND"
        },
        {
            date: "13/04/2025",
            type: "Chèque",
            ttc: "Paiement facture de vente ",
            document: "FAC-000003",
            debit: "--",
            credit: "75,000 TND"
        },
        {
            date: "14/04/2025",
            type: "Espèces",
            ttc: "Paiement fournisseur ",
            document: "ACH-000011",
            debit: "--",
            credit: "10,000 TND"
        }];
    selectedMonthIndex: number | null = null;
    selectedDay: string = '';
    selectedYear: number | null = null;
    selectedDate: Date | null = null;

    archiveData: Quote[] = [];
    filteredData: Quote[] = [];
    paginatedData: Quote[] = [];
    searchTerm = '';
    showFilter = false;

    newStatus = '';
    basicSelectedOption = 10;
    currentPage = 1;
    totalPages = 1;
    pages: number[] = [];
    filterSummary = '';

    perPage = 5;
    pageOptions = [5, 10, 20];
    statuses = ['Tous', 'Brouillon', 'Créé', 'Annulé', 'Négociation', 'Accepté'];

    filters: any = {
        raison: '',
        matricule: '',
        chiffre_aff: '',
        operator: '=',
        status: ''
    };

    selectedPeriod = '';

    months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];

    years: number[] = [];

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private router: Router,
        private modalService: NgbModal,
        private headerService: HeaderService
    ) {
    }

    ngOnInit() {

        const today = new Date();
        this.selectedDate = today;
        this.selectedDay = today.toISOString().split('T')[0];
        this.selectedMonthIndex = today.getMonth();
        this.selectedYear = today.getFullYear();
        this.updateSelectedPeriod();
        // Ne pas appliquer de filtre au démarrage - toutes les données seront affichées
        // this.dataService.filterByDateRange(this.selectedDay, this.selectedDay);
        
        // Ne pas émettre l'événement initial - le composant parent affichera toutes les données par défaut
        // this.dateFilterChange.emit({startDate: this.selectedDay, endDate: this.selectedDay});

        this.dataService.tableData$.subscribe(data => {
            this.archiveData = data;
            this.updateFilteredData();
        });

        this.generateWeekDays();
        this.years = Array.from({length: 10}, (_, i) => this.currentYear - i).reverse();
    }

    ngAfterViewInit() {
      //  setTimeout(() => Feather.replace(), 0);
        this.initializeFlatpickr();
    }

    generateWeekDays() {
        const today = new Date();
        const startOfWeek = new Date(this.selectedDate || today);
        startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay() + 1);

        this.weekDays = Array.from({length: 7}, (_, i) => {
            const d = new Date(startOfWeek);
            d.setDate(startOfWeek.getDate() + i);
            const dayName = d.toLocaleDateString('fr-FR', {weekday: 'short'});
            const dayNumber = d.getDate();
            return {
                label: `${dayName}. ${dayNumber}`,
                dateString: d.toISOString().split('T')[0],
                isToday: d.toDateString() === today.toDateString()
            };
        });
    }

    selectDay(day: any) {
        this.selectedDay = day.dateString;
        this.selectedDate = new Date(day.dateString);
        this.selectedMonthIndex = this.selectedDate.getMonth();
        this.selectedYear = this.selectedDate.getFullYear();
        this.updateSelectedPeriod();
        this.dataService.filterByDateRange(day.dateString, day.dateString);
        this.updateFilterSummary();
        // Émettre l'événement pour le composant parent
        this.dateFilterChange.emit({startDate: day.dateString, endDate: day.dateString});
    }

    selectMonth(index: number) {
        this.selectedMonthIndex = index;
        let startDate: string;
        let endDate: string;
        
        // Toujours utiliser la plage complète du mois, même si une année est sélectionnée
        const year = this.selectedYear !== null ? this.selectedYear : this.currentYear;
        startDate = new Date(year, index, 1).toISOString().split('T')[0];
        endDate = new Date(year, index + 1, 0).toISOString().split('T')[0];
        
        this.selectedDate = new Date(year, index, 1);
        this.selectedDay = '';
        this.selectedPeriod = `Mois: ${this.months[index]} ${year}`;
        this.selectedYear = year;
        
        this.dataService.filterByDateRange(startDate, endDate);
        this.updateFilterSummary();
        // Émettre l'événement pour le composant parent avec la plage complète du mois
        this.dateFilterChange.emit({startDate, endDate});
    }

    selectYear(year: number) {
        this.selectedYear = year;
        let startDate: string;
        let endDate: string;
        
        // Si un mois est sélectionné, utiliser la plage complète du mois de cette année
        if (this.selectedMonthIndex !== null) {
            const monthIndex = this.selectedMonthIndex;
            startDate = new Date(year, monthIndex, 1).toISOString().split('T')[0];
            endDate = new Date(year, monthIndex + 1, 0).toISOString().split('T')[0];
            this.selectedDate = new Date(year, monthIndex, 1);
            this.selectedDay = '';
            this.selectedPeriod = `Mois: ${this.months[monthIndex]} ${year}`;
        } else {
            // Sinon, utiliser la plage complète de l'année
            startDate = `${year}-01-01`;
            endDate = `${year}-12-31`;
            this.selectedDate = new Date(year, 0, 1);
            this.selectedDay = '';
            this.selectedMonthIndex = null;
            this.selectedPeriod = `Année: ${year}`;
        }
        
        this.dataService.filterByDateRange(startDate, endDate);
        this.updateFilterSummary();
        // Émettre l'événement pour le composant parent avec la plage complète
        this.dateFilterChange.emit({startDate, endDate});
    }

    changeViewMode(mode: 'jours' | 'mois' | 'annees'): void {
        this.viewMode = mode;
        // Quand on change de mode, appliquer le filtre selon le mode actuel
        if (mode === 'jours') {
            const dayToUse = this.selectedDay || new Date().toISOString().split('T')[0];
            this.selectDay({dateString: dayToUse});
        } else if (mode === 'mois') {
            const monthIndex = this.selectedMonthIndex !== null ? this.selectedMonthIndex : this.currentMonthIndex;
            this.selectMonth(monthIndex);
        } else if (mode === 'annees') {
            const year = this.selectedYear !== null ? this.selectedYear : this.currentYear;
            this.selectYear(year);
        }
    }

    incrementDate() {
        if (this.selectedDate) {
            let startDate: string;
            let endDate: string;
            if (this.viewMode === 'mois') {
                this.selectedDate.setMonth(this.selectedDate.getMonth() + 1);
                const year = this.selectedDate.getFullYear();
                const monthIndex = this.selectedDate.getMonth();
                startDate = new Date(year, monthIndex, 1).toISOString().split('T')[0];
                endDate = new Date(year, monthIndex + 1, 0).toISOString().split('T')[0];
            } else if (this.viewMode === 'annees') {
                this.selectedDate.setFullYear(this.selectedDate.getFullYear() + 1);
                const year = this.selectedDate.getFullYear();
                startDate = `${year}-01-01`;
                endDate = `${year}-12-31`;
            } else {
                this.selectedDate.setDate(this.selectedDate.getDate() + 1);
                startDate = this.selectedDate.toISOString().split('T')[0];
                endDate = startDate;
            }
            this.selectedDay = this.selectedDate.toISOString().split('T')[0];
            this.selectedMonthIndex = this.selectedDate.getMonth();
            this.selectedYear = this.selectedDate.getFullYear();
            this.updateSelectedPeriod();
            this.dataService.filterByDateRange(startDate, endDate);
            this.generateWeekDays();
            this.updateFilterSummary();
            // Émettre l'événement pour le composant parent
            this.dateFilterChange.emit({startDate, endDate});
        }
    }

    decrementDate() {
        if (this.selectedDate) {
            let startDate: string;
            let endDate: string;
            if (this.viewMode === 'mois') {
                this.selectedDate.setMonth(this.selectedDate.getMonth() - 1);
                const year = this.selectedDate.getFullYear();
                const monthIndex = this.selectedDate.getMonth();
                startDate = new Date(year, monthIndex, 1).toISOString().split('T')[0];
                endDate = new Date(year, monthIndex + 1, 0).toISOString().split('T')[0];
            } else if (this.viewMode === 'annees') {
                this.selectedDate.setFullYear(this.selectedDate.getFullYear() - 1);
                const year = this.selectedDate.getFullYear();
                startDate = `${year}-01-01`;
                endDate = `${year}-12-31`;
            } else {
                this.selectedDate.setDate(this.selectedDate.getDate() - 1);
                startDate = this.selectedDate.toISOString().split('T')[0];
                endDate = startDate;
            }
            this.selectedDay = this.selectedDate.toISOString().split('T')[0];
            this.selectedMonthIndex = this.selectedDate.getMonth();
            this.selectedYear = this.selectedDate.getFullYear();
            this.updateSelectedPeriod();
            this.dataService.filterByDateRange(startDate, endDate);
            this.generateWeekDays();
            this.updateFilterSummary();
            // Émettre l'événement pour le composant parent
            this.dateFilterChange.emit({startDate, endDate});
        }
    }

    updateSelectedPeriod() {
        const dateToUse = this.selectedDate || new Date();
        const month = this.months[dateToUse.getMonth()];
        const day = dateToUse.getDate();
        const year = dateToUse.getFullYear();
        this.selectedPeriod = `${month} ${day}, ${year}`;
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
        if (this.showFilter) {
          //  setTimeout(() => Feather.replace(), 0);
        }
    }

    onSearch() {
        this.updateFilteredData();
    }

    initializeFlatpickr() {
        if (this.datePicker) {
            flatpickr(this.datePicker.nativeElement, {
                locale: French,
                mode: 'range',
                dateFormat: 'Y-m-d',
                defaultDate: [this.selectedDay, this.selectedDay],
                onChange: (selectedDates) => {
                    if (selectedDates.length === 2) {
                        const startDate = selectedDates[0].toISOString().split('T')[0];
                        const endDate = selectedDates[1].toISOString().split('T')[0];
                        this.selectedPeriod = `${this.formatDate(startDate)} - ${this.formatDate(endDate)}`;
                        this.selectedMonthIndex = null;
                        this.selectedDay = '';
                        this.selectedYear = null;
                        this.selectedDate = null;
                        this.dataService.filterByDateRange(startDate, endDate);
                        this.updateFilterSummary();
                        // Émettre l'événement pour le composant parent
                        this.dateFilterChange.emit({startDate, endDate});
                    } else if (selectedDates.length === 1) {
                        const singleDate = selectedDates[0].toISOString().split('T')[0];
                        this.dateFilterChange.emit({startDate: singleDate, endDate: singleDate});
                    }
                }
            });
        }
    }

    openFlatpickr() {
        if (this.datePicker?.nativeElement?._flatpickr) {
            this.datePicker.nativeElement._flatpickr.open();
        }
    }

    formatDate(dateString: string) {
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR');
    }

    updateFilterSummary() {
        const activeFilters = [];
        if (this.filters.raison) activeFilters.push(`Raison: ${this.filters.raison}`);
        if (this.filters.matricule) activeFilters.push(`Matricule: ${this.filters.matricule}`);
        if (this.filters.chiffre_aff) activeFilters.push(`Chiffre: ${this.filters.operator} ${this.filters.chiffre_aff}`);
        if (this.filters.status) activeFilters.push(`Statut: ${this.filters.status}`);
        if (this.selectedPeriod) activeFilters.push(this.selectedPeriod);
        this.filterSummary = activeFilters.join(', ');
    }

    resetFilters() {
        this.filters = {raison: '', matricule: '', chiffre_aff: '', operator: '=', status: ''};
        const today = new Date();
        this.selectedDate = today;
        this.selectedDay = today.toISOString().split('T')[0];
        this.selectedMonthIndex = today.getMonth();
        this.selectedYear = today.getFullYear();
        this.updateSelectedPeriod();
        this.dataService.filterByDateRange(this.selectedDay, this.selectedDay);
        this.updateFilteredData();
    }

    applyFilters() {
        this.updateFilteredData();
        this.toggleFilter();
    }

    updateFilteredData() {
        this.filteredData = this.archiveData.filter(item =>
            (item.reference?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
            (item.clientName?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '') ||
            (item.email?.toLowerCase().includes(this.searchTerm.toLowerCase()) || '')
        );

        if (this.filters.raison) {
            this.filteredData = this.filteredData.filter(item =>
                item.clientName?.toLowerCase().includes(this.filters.raison.toLowerCase())
            );
        }
        if (this.filters.matricule) {
            this.filteredData = this.filteredData.filter(item =>
                item.matricule?.toLowerCase().includes(this.filters.matricule.toLowerCase())
            );
        }
        if (this.filters.chiffre_aff) {
            this.filteredData = this.filteredData.filter(item => {
                const revenue = parseFloat(item.revenue.replace(',', '.').replace(' TND', '') || '0');
                const filterValue = parseFloat(this.filters.chiffre_aff);
                if (this.filters.operator === '=') return revenue === filterValue;
                if (this.filters.operator === '>') return revenue > filterValue;
                if (this.filters.operator === '<') return revenue < filterValue;
                return true;
            });
        }
        if (this.filters.status) {
            this.filteredData = this.filteredData.filter(item => item.status === this.filters.status);
        }

        this.updateFilterSummary();
        this.updatePagination();
    }

    updatePagination() {
        this.totalPages = Math.ceil(this.filteredData.length / this.basicSelectedOption);
        this.currentPage = Math.min(this.currentPage, this.totalPages || 1);
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        const start = (this.currentPage - 1) * this.basicSelectedOption;
        this.paginatedData = this.filteredData.slice(start, start + this.basicSelectedOption);
    }

    changePage(page: number) {
        this.currentPage = page;
        this.updatePagination();
    }


    openSaveModal() {
        //  this.saveComponent.data = data;
        this.saveComponent.openModal();
    }


}